import { Box, TableCell, Typography } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { Attendance, AttendanceRequest, AttendanceUpdateRequest } from "../../../service/model/attendance.model";
import { useState } from "react";
import AttendanceForm from "./attendance-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { deleteAttendance, updateAttendance } from "../attendance.slice";
import TableActionButton from "../../../components/table/table-action-button";
import { selectLoggedInUser } from "../../auth/auth.slice";
import { CircleIcon, DeleteIcon, EditIcon } from "../../../shared/icons";

interface TableRowProps {
    readonly attendance: Attendance
}

const AttendanceTableRow: React.FC<TableRowProps> = ({ attendance }) => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showAttendanceForm, setShowAttendanceForm] = useState(false);

    const handleDelete = () => {
        dispatch(deleteAttendance(attendance.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: AttendanceRequest) => {
        const updateRequest: AttendanceUpdateRequest = {
            id: attendance.id,
            attendanceData: {
                ...data,
                markedByType: 'STAFF',
                markedByUserId: loggedInUser?.user.id
            }
        };
        dispatch(updateAttendance(updateRequest)).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowAttendanceForm(false);
            }
        });
    };

    const getCircleColor = (status: string) => {
        if (status === 'ACTIVE') return 'green';
        else if (status === 'EXPIRED') return 'red';
        else return 'grey';
    }

    return (
        <>
            <StyledTableRow key={attendance.id}>
                <TableCell>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <CircleIcon sx={{ width: '12px', color: getCircleColor(attendance.memberStatusAtCheckIn) }} />
                        <Typography variant="body2">{attendance.memberName}</Typography>
                    </Box>
                </TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Check In</Box>{attendance.checkIn.replace('T', ' ')}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Marker Type</Box>{attendance.markedByType}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Marked By</Box>{attendance.markedByName || "—"}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <IconButton onClick={() => setShowAttendanceForm(true)} sx={{color: `${theme.palette.secondary.main}`, paddingLeft: 0}}><VisibilityIcon /></IconButton> */}
                    <TableActionButton onClick={() => setShowAttendanceForm(true)} label="Edit" icon={<EditIcon />} disabled={attendance.markedByType === 'FINGERPRINT'} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} disabled={attendance.markedByType === 'FINGERPRINT'} />
                    {/* <Link className="btn" to="#" data-toggle="modal" data-target="#delete-member-modal" onClick={() => setShowDeleteDialog(true)}><DeleteIcon /></Link> */}
                </TableCell>
            </StyledTableRow>
            {showAttendanceForm &&
                <AttendanceForm attendance={attendance} editable={true} onClose={() => setShowAttendanceForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message={<>Are you sure you want to delete attendance for <strong>{attendance.memberName}</strong> on <strong>{attendance.checkIn.substring(0, 10)}</strong>?</>} onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default AttendanceTableRow;